import React, { createContext, useState, useContext, useEffect } from 'react';

// Create auth context
const AuthContext = createContext();

// Custom hook to use auth context
export const useAuth = () => {
  return useContext(AuthContext);
};

// Auth provider component
export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  // Check localStorage for auth state on initial load
  useEffect(() => {
    const checkLoggedIn = () => {
      const storedLoginState = localStorage.getItem('isAdminLoggedIn') === 'true';
      setIsLoggedIn(storedLoginState);
      setLoading(false);
    };
    
    checkLoggedIn();
  }, []);

  // Login function
  const login = (userId, password) => {
    return new Promise((resolve, reject) => {
      // For demo purposes, hardcoded credentials
      // In a real app, this would make an API call to validate credentials
      if (userId === 'admin' && password === 'admin123') {
        localStorage.setItem('isAdminLoggedIn', 'true');
        setIsLoggedIn(true);
        resolve({ success: true });
      } else {
        reject(new Error('Invalid credentials'));
      }
    });
  };

  // Logout function
  const logout = () => {
    localStorage.removeItem('isAdminLoggedIn');
    setIsLoggedIn(false);
  };

  // Auth context value
  const value = {
    isLoggedIn,
    loading,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export default AuthContext; 